import { useRef } from 'react';
import isIos from '../utils/isIos';

export default function useIsIos() {
  const isIosRef = useRef<boolean | null>(null);

  if (isIosRef.current === null && typeof window !== 'undefined') {
    isIosRef.current = isIos();
  }

  return isIosRef.current ?? false;
}
